import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { LinkSidebarContainer } from "./styled/Components";

import DirectLink from "./DirectLink";
import Email from "./Email";
import Pages from "./Pages";

import { findOption } from "../../../../components/ui/link-picker/LinkService";
import {
  SOURCES_OPTIONS,
  LinkTypes,
} from "../../../../components/ui/link-picker/LinkTypes";
import { Select } from "@caelor/ui";
import { useTranslation } from "react-i18next";

const SelectContainer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  font-family: "PP Formula";
  border-bottom: 1px solid ${({ theme }) => theme.border.black10};
  padding-bottom: 25px;
  margin-bottom: 15px;
`;

const LinkSidebar = ({ value, setValue }) => {
  const { source } = value || {};
  const { t } = useTranslation();
  const sourceOptions = SOURCES_OPTIONS(t);

  const [selected, setSelected] = useState(findOption(source, t));

  useEffect(() => {
    if (source !== selected.value) {
      setSelected(findOption(source, t));
    }
  }, [value, t]);

  return (
    <>
      <SelectContainer>
        <span>Link to</span>

        <Select
          value={selected}
          onChange={setSelected}
          options={sourceOptions}
        />
      </SelectContainer>

      <LinkSidebarContainer>
        {selected.value === LinkTypes.PAGE && (
          <Pages value={value} setValue={setValue} />
        )}
        {selected.value === LinkTypes.LINK && (
          <DirectLink value={value} setValue={setValue} />
        )}
        {selected.value === LinkTypes.EMAIL && (
          <Email value={value} setValue={setValue} />
        )}
      </LinkSidebarContainer>
    </>
  );
};

LinkSidebar.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  setValue: PropTypes.func.isRequired,
};

LinkSidebar.displayName = "LinkSidebar";

export default LinkSidebar;
